import { FCX, SuggestedSearches as PlatformSuggestedSearches } from "@datassential/platform-ui-lib";
import { useMemo } from "react";
import { excludeNullable, mapByKey, randomizeItems } from "@core/utils/array";
import cn from "classnames";
import { useCommonDataContext } from "@core/CommonDataContext";
import useApplySearch from "@vms/ToolSearch/useApplySearch";

const SuggestedSearches: FCX = () => {
    const { isLoading: isSuggestedSearchesLoading, suggestedSearches: rawSuggestedSearches } = useCommonDataContext();
    const applySearch = useApplySearch();

    const suggestedSearches = useMemo(
        () => randomizeItems(
            excludeNullable(
                mapByKey(rawSuggestedSearches ?? [], 'text')
            ),
            3
        ),
        [rawSuggestedSearches]
    );

    if (isSuggestedSearchesLoading || !suggestedSearches.length) return null;

    return (
        <PlatformSuggestedSearches
            className={cn(
                "ToolSearch__recent-searches",
                "ToolSearchRecentSearches",
                "appears-top",
                "fast"
            )}
            searches={suggestedSearches}
            title={"Suggested Questions"}
            onSearchClick={applySearch}
        />
    );
};

export default SuggestedSearches;